import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';

const StampaPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Area Stampa' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Media" title="Area Stampa" subtitle="Comunicati, cartelle stampa e risorse per i giornalisti. Per richieste urgenti: stampa@giovanidemocratici.it" />
      <section className="section section--sm"><div className="container">
        <h2 className="h3 mb-6">Ultimi comunicati stampa</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
          {[
            { title: 'Assemblea Nazionale: il documento approvato', date: '15 Mar 2026' },
            { title: 'GD su salario minimo: "Serve subito una legge"', date: '10 Mar 2026' },
            { title: 'Giornata Internazionale della Donna: le nostre proposte', date: '8 Mar 2026' },
            { title: 'Forum Giovani e Lavoro: programma e relatori', date: '5 Mar 2026' },
            { title: 'Dichiarazione congiunta GD-PD sul precariato giovanile', date: '1 Mar 2026' },
          ].map((c) => (
            <Link to="/articolo" className="card" style={{ padding: 'var(--space-5)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} key={c.title}>
              <div><h4 className="mb-1">{c.title}</h4><span className="text-meta">{c.date}</span></div>
              <span className="badge badge--subtle">PDF</span>
            </Link>
          ))}
        </div>
        <div className="mt-12">
          <h2 className="h3 mb-6">Risorse Media</h2>
          <div className="grid grid-3">
            {[
              { title: 'Loghi Ufficiali', img: 'https://images.unsplash.com/photo-1572044162444-ad60f128bdea?q=80&w=600&auto=format&fit=crop' },
              { title: 'Foto Segretario', img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=600&auto=format&fit=crop' },
              { title: 'Kit Social', img: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=600&auto=format&fit=crop' },
            ].map((r) => (
              <div className="card overflow-hidden" key={r.title}>
                <div style={{ aspectRatio: '16/9' }}>
                  <img src={r.img} alt={r.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ padding: 'var(--space-4)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: 600 }}>{r.title}</span>
                  <button className="btn btn--link btn--sm">Scarica</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <h2 className="h3 mb-4">Contatto stampa</h2>
          <div className="card" style={{ padding: 'var(--space-6)' }}>
            <p className="mb-2"><strong>Ufficio Stampa GD</strong></p>
            <p className="text-body-sm text-secondary mb-1">Email: <a href="mailto:stampa@giovanidemocratici.it" className="link">stampa@giovanidemocratici.it</a></p>
            <p className="text-body-sm text-secondary">Tel: +39 06 6711 3201</p>
          </div>
        </div>
      </div></section>
    </Layout>
  );
};

export default StampaPage;
